var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('span',{class:{ 'error--text': _vm.error }},[_c('Amount',{attrs:{"currency":_vm.crnc_code},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }